<template>
      <div class="property-warning-info">
        <img src="@/assets/images/info.svg" alt="" />
        {{ text }}
      </div>
</template>

<script>

export default {
  name: 'BannerInfo',
  components: {
  },
  props: {
    text: {
      type: String,
      reuqired: true,
    },
  },
  data() {
    return {

    };
  },
  computed: {
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
.property-warning-info{
    @apply ut-p-4 ut-mb-3 ut-text-sm;
    background-color: #fef7e3;
    border-radius: 3px;
    img {
        @apply ut-mr-3 ut-float-left;
        width: 20px;
        vertical-align: middle;
    }
}
</style>
